import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5b8f0938"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["onSubmit"];
const _hoisted_2 = { class: "table-column-search__actions" };
import { Close, Search } from '@element-plus/icons-vue';
import { ref, watch, nextTick } from 'vue';
var SearchEvents;
(function (SearchEvents) {
    SearchEvents["UpdateNameSearch"] = "update:nameSearch";
    SearchEvents["ClearNameSearch"] = "clear:nameSearch";
})(SearchEvents || (SearchEvents = {}));
export default /*#__PURE__*/ _defineComponent({
    __name: 'TableColumnSearch',
    props: {
        loading: { type: Boolean },
        searchTerm: {},
        backendFilterKey: {},
        backendParams: {},
        backendTransform: { type: Function }
    },
    emits: [
        'update:nameSearch',
        'clear:nameSearch',
        'backend:response',
        'backend:error',
        'backend:applied',
    ],
    setup(__props, { emit }) {
        const props = __props;
        const searchTerm = ref(props.searchTerm || '');
        const inputRef = ref();
        watch(() => props.searchTerm, newValue => {
            searchTerm.value = newValue || '';
        }, { immediate: true });
        function clearSearch() {
            searchTerm.value = '';
            // Modo backend
            if (props.backendFilterKey && props.backendParams) {
                emit('backend:applied', {
                    key: props.backendFilterKey,
                    value: '',
                });
                return;
            }
            // Modo normal: componente só emite evento
            emit(SearchEvents.ClearNameSearch, '');
        }
        async function search() {
            // Modo backend genérico
            if (props.backendFilterKey && props.backendParams) {
                const transformed = props.backendTransform ? props.backendTransform(searchTerm.value) : searchTerm.value;
                emit('backend:applied', {
                    key: props.backendFilterKey,
                    value: transformed,
                });
                return;
            }
            // Modo padrão: sem backend
            emit(SearchEvents.UpdateNameSearch, searchTerm.value);
        }
        async function focusInput() {
            await nextTick();
            inputRef.value?.focus();
        }
        return (_ctx, _cache) => {
            const _component_el_input = _resolveComponent("el-input");
            const _component_el_button = _resolveComponent("el-button");
            const _component_el_popover = _resolveComponent("el-popover");
            return (_openBlock(), _createBlock(_component_el_popover, {
                width: "300",
                onShow: focusInput
            }, {
                reference: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "reference")
                ]),
                default: _withCtx(() => [
                    _createElementVNode("form", {
                        onSubmit: _withModifiers(search, ["prevent"]),
                        class: "table-column-search"
                    }, [
                        _createVNode(_component_el_input, {
                            ref_key: "inputRef",
                            ref: inputRef,
                            modelValue: searchTerm.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchTerm).value = $event)),
                            size: "small",
                            placeholder: _ctx.$t('table-column.placeholder')
                        }, null, 8, ["modelValue", "placeholder"]),
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(_component_el_button, {
                                size: "small",
                                icon: _unref(Close),
                                onClick: clearSearch
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('table-column.btn-reset')), 1)
                                ]),
                                _: 1
                            }, 8, ["icon"]),
                            _createVNode(_component_el_button, {
                                size: "small",
                                type: "primary",
                                icon: _unref(Search),
                                onClick: search
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('table-column.btn-search')), 1)
                                ]),
                                _: 1
                            }, 8, ["icon"])
                        ])
                    ], 40, _hoisted_1)
                ]),
                _: 3
            }));
        };
    }
});
